import React, { Suspense } from 'react';
import BaseLayout from 'components/BaseLayout/BaseLayout';
import UIPageTitle from 'components/UI/PageTitle/PageTitle';
import DocumentTitle from 'components/DocumentTitle/DocumentTitle';
import UILoader from 'components/UI/Loader/Loader';

const BatchAssignPlacements = React.lazy(
  () => import('components/Tools/BatchAssignPlacements/BatchAssignPlacements'),
);

function ScreensToolsBatchAssignPlacements() {
  return (
    <BaseLayout>
      <DocumentTitle>Batch Assign Placements</DocumentTitle>
      <UIPageTitle description="Assign multiple placements to a campaign">
        Batch Assign Placements
      </UIPageTitle>
      <Suspense fallback={<UILoader />}>
        <BatchAssignPlacements />
      </Suspense>
    </BaseLayout>
  );
}

export default ScreensToolsBatchAssignPlacements;
